import React, { useEffect, useState } from "react";
import { Button, Checkbox, Form, Skeleton, message, Row, Col } from "antd";
import { SaveButton, InputText, CancelButton, ModalComponent, trans, InputDate } from "@comps/components"
import { makeRequest, getErrorProps } from "@utils/helpers";
import { Commons, Const } from "../../constants";
import dayjs from 'dayjs';
import { useSelector } from "react-redux";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { SelectResourceList, SelectWithSearch } from "../../../../wrappers/components";
import { createSelectList } from "../../../../wrappers/commonFunctions";
import { createDataReq, getTargetIncetiveConfigReq } from "../requests";
import { makeFieldLabel } from "@utils/fieldTooltips";
import { taskTooltips } from "../../common/taskTooltips";
const langKey = Const["caseSheet"].lngKey
const fieldLabel = makeFieldLabel(taskTooltips.caseSheet, { namespace: "caseSheet", label: (key) => trans(`${langKey}.${key}`) });
const formName = "createLendType";

const CreateCaseSheet = (props) => {

  const authUser = useSelector((state) => state.auth.authUser);
  const [loader, setLoader] = useState(false);
  const [saving, setsaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState([]);
  const [childComponent, setChildComponent] = useState(false)
  const [lend, setLend] = useState({});
  const [repayments, setRepayments] = useState([]);
  const [totalAmount, setTotalAmount] = useState(null)
  const [approvedAmount, setApprovedAmount] = useState(null);
  const [deletedRows, setDeletedRows] = useState([])
  const [targetConfig, setTargetConfig] = useState({})
  const [form] = Form.useForm()
  useEffect(() => {
    getRelated()
    // eslint-disable-next-line
  }, []);
  const getRelated = () => {
    makeRequest(setLoader, getTargetIncetiveConfigReq, null, onSuccessGetting, onErrorGettingData);
  }

  const onSuccessGetting = (data, res) => {
    setTargetConfig(createSelectList(data.data))
    message.success("Data fetched successfully");
  }

  const onErrorGettingData = (err, res) => {
    message.error(res.response.data.message);
  }

  const getPaidAmount = (lend) => {
    var total = 0;
    for (var i in lend.repayments) {
      if (lend.repayments[i] && lend.repayments[i].processed) {
        total += lend.repayments[i].amount;
      }
    }
    return total;
  }


  const onChangeAmount = (amount) => {
    const paid_amount = form.getFieldValue('paid_amount')
    const balance = amount - paid_amount
    form.setFieldValue('remaining_amount', balance)
  }

  const getTotalAmount = () => {
    const values = form.getFieldValue('cases')
    let totalachieved_target = 0
    values.forEach((value) => {
      if (value !== undefined) {
        let achieved_target = value.achieved_target !== undefined ? parseFloat(value.achieved_target) : 0
        if (value.achieved_target === undefined || value.achieved_target === '') {
          achieved_target = 0
        }
        totalachieved_target = totalachieved_target + achieved_target
      }
    })
    setTotalAmount(totalachieved_target)
  }

  //save
  const onSubmit = (data) => {

    let newList = []
    let cases = data.cases;


    if (!cases) {
      message.error("Please add at least one case.");
      return;
    }
    if (cases.length === 0) {
      message.error("Please add at least one case.");
      return;
    }
    cases && cases.forEach((each) => {

      if (!each.no_more_cases_available) {
        each.no_more_cases_available = false
      }

      if (each.date !== undefined && each.date) {
        if (each.date.isValid()) {
          each.date = each.date.format("YYYY-MM-DD");
        } else {
          each.date = each.date;  // If the date is invalid, set it to null
        }
      } else {
        each.date = null
      }

      each.employment_id = data.employment_id;
      each.target_incentive_configuration_id = data.target_id;
      each.achieved_target = Number(each.achieved_target) || 0; // Ensure achieved_target is a number

      newList.push(each)
    })
    const payload = { ...data, cases: newList };

    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
    cases.forEach((each) => {
      each.repayment_date = dayjs(each.repayment_date);
    })
    setsaving(true)
  }

  const onSuccess = (data, res) => {
    setsaving(false)
    message.success("Saved successfully");
    props.onCompleted(data);
  }

  const onError = (err, res) => {

    setsaving(false)
    message.error(res.response.data.message);
  }
  //==============add details =================
  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  const footer = [
    props.disabled ? '' :
      <SaveButton loading={ saving } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 1200 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ "case sheet" }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      { childComponent }
      <Skeleton loading={ loader }>

        <Form { ...formLayout } name={ formName } onFinish={ onSubmit } form={ form } scrollToFirstError>
          <Row gutter={ 30 }>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="target_id" rules={ rules.target_id } label={ fieldLabel("target_id", "Target") }
                className="da-mb-16"

              >
                <SelectWithSearch
                  options={ targetConfig }
                  placeholder={ "Target Incentive" }
                />

              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="employment_id" rules={ rules.employment_id } label={ fieldLabel("employment_id", "Employee") }
                className="da-mb-16"

              >
                <SelectResourceList
                  type="employment"
                  placeholder={ "Employee" }
                />

              </Form.Item>
            </Col>


          </Row>

          <div className="formlist-container">
            <h5 className="formlist-title">Cases Record</h5>

            <Form.List name="cases" >
              { (fields, { add, remove }) => (
                <>

                  <div className="table-container">
                    <table className="table">
                      {
                        fields.length !== 0 && <thead>
                          <tr>
                            <th style={ { paddingLeft: 20 } }>{ trans(`${langKey}.date`) }</th>
                            <th>{ "Achived" }</th>
                            <th>{ "No More" }</th>
                            <th>{ "Actions" }</th>
                          </tr>
                        </thead>
                      }
                      <tbody>
                        { fields.map(({ key, name, ...restField }) => (
                          <>
                            <tr>
                              <td style={ { minWidth: '200px', paddingLeft: 20 } }>

                                <Form.Item
                                  { ...restField }
                                  name={ [name, 'date'] }
                                  rules={ rules.date }
                                >
                                  <InputDate />
                                </Form.Item>
                              </td>
                              <td style={ { minWidth: '200px' } }>
                                <Form.Item
                                  { ...restField }
                                  name={ [name, 'achieved_target'] }
                                  rules={ rules.achieved_target }
                                  initialValue={ 0 }
                                >
                                  <InputText

                                    type="number" onWheel={ (e) => e.target.blur() }
                                    onChange={ () => getTotalAmount() }

                                  />
                                </Form.Item>
                              </td>
                              <td style={ { minWidth: '200px' } }>
                                <Form.Item
                                  valuePropName="checked"
                                  { ...restField }
                                  name={ [name, 'no_more_cases_available'] }
                                  rules={ rules.no_more_cases_available }
                                >
                                  <Checkbox />
                                </Form.Item>
                              </td>

                              <td>
                                <DeleteOutlined className="formlist-remove" onClick={ () => {
                                  remove(name)
                                  getTotalAmount()
                                  //setRows(key, 'Deleted')
                                } } />
                              </td>


                            </tr>
                          </>
                        )) }
                        <tr style={ { fontWeight: 'bold' } }>
                          <td >
                            Total Achived Cases:
                          </td>
                          <td colspan={ 4 } >
                            { totalAmount }
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div style={ { float: 'left', marginTop: 50, marginLeft: 5 } }>
                      <Button onClick={ () => {
                        add()
                        // setRows(fields.length, 'Added')
                      } } icon={ <PlusOutlined /> } type="primary" className="add-node-button">Add Item</Button>
                    </div>
                  </div>

                </>
              ) }
            </Form.List>
          </div>

        </Form>

      </Skeleton>

    </ModalComponent>
  )
}

export default CreateCaseSheet

const rules = {
  date: [
    { required: true, message: trans(`${langKey}.date.req`) },
  ],

  target_id: [
    { required: true, message: "Target" },
  ],
  employment_id: [
    { required: true, message: "Employee" },
  ],


};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
